module.exports = __webpack_public_path__ + "img/02-babo-01.76e047ec.png";